module.exports = __webpack_public_path__ + "img/boost-1680.3ddb2fd.png";